"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecret = exports._resetClient = void 0;
const webapp_constants_1 = require("@eventbrite/webapp-constants");
const clients_1 = require("./clients");
let client;
const getSecretsClient = () => {
    if (client) {
        return client;
    }
    const stage = (0, webapp_constants_1.stageFromString)(process.env.STAGE || webapp_constants_1.Stage.LOCAL);
    const USE_SECRETS_MANAGER_CLIENT = process.env.USE_SECRETS_MANAGER_CLIENT;
    if (stage === webapp_constants_1.Stage.LOCAL || USE_SECRETS_MANAGER_CLIENT) {
        return new clients_1.AWSSecretsManagerClient();
    }
    return new clients_1.LocalSecretsLayerClient();
};
const _resetClient = () => {
    client = null;
};
exports._resetClient = _resetClient;
/**
 * Fetches a secret from the secret manager. The secret manager is determined by the STAGE environment variable.
 * in Local it is fetched using the secrets manager client, in any other stage it is fetched using the local client provided by the layer
 * @param {string} secretId The ARN or name of the secret to retrieve. For an ARN, we recommend that you specify a complete ARN rather than a partial ARN.
 * @returns {Promise<GetSecretValueResponse>} the response from the secret manager
 */
const getSecret = async (secretId) => {
    client = getSecretsClient();
    return client.fetchSecretValue(secretId);
};
exports.getSecret = getSecret;
//# sourceMappingURL=getSecret.js.map